import styled from 'styled-components';
import { Field } from '../field';
export const CustomField = styled(Field) `
  border: none;
  background: transparent;
  padding: 0;
  flex-direction: ${({ direction }) => direction !== null && direction !== void 0 ? direction : 'column'};
  gap: ${({ direction }) => direction === 'row' ? '48px' : '0'};
  align-items: start;
  margin: ${({ direction }) => direction === 'row' ? '0 32px 0 0' : '0 0 32px 0'};
  `;
export const RadioButtonComponent = styled.div `
  display: flex;
  position: relative;
  margin: 10px 0;
  padding-left: 20px;
  `;
export const CustomInput = styled.input `
  top: 0;
	left: 0;
	position: absolute;
  
  opacity: 0;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'}; 
  z-index: 1;
  margin: 0;
  padding: 0;
  height: ${({ fieldOptions }) => fieldOptions === 'small' ? '16px' : '20px'};
  width: ${({ fieldOptions }) => fieldOptions === 'small' ? '16px' : '20px'} ;

  &:not(:disabled){
    &:focus ~ span, &:active ~ span{
      border: 2px solid ${({ theme }) => theme.colors.secondary.lighten};
      background: transparent;
    }

    &:checked ~ span {
      background-color: transparent;
      border: 6px solid ${({ theme }) => theme.colors.secondary.lighten};
    }

    &:checked ~ span:after {
      display: block;
    }
  }

  &:disabled {
    & ~ span{
    border: 2px solid ${({ theme }) => theme.colors.grey24};
    }
  }
  `;
export const OptionLabel = styled.label `
  display: inline-block;
  margin-left: ${({ fieldOptions }) => fieldOptions === 'small' ? '16px' : '12px'};
  font-size: ${({ fieldOptions }) => fieldOptions === 'small' ? '14px' : '16px'};
  color: ${({ disabled, theme }) => disabled ? theme.colors.grey24 : theme.colors.grey84};
  line-height: 20px;
  cursor: pointer;
  `;
export const Checkmark = styled.span `
  position: absolute;
  top: 0;
  left: 0;
  height: ${({ fieldOptions }) => fieldOptions === 'small' ? '16px' : '20px'};
  width: ${({ fieldOptions }) => fieldOptions === 'small' ? '16px' : '20px'};
  border-radius: 50%;
  border: 2px solid #ccc;

  &:after {
    content: "";
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: ${({ fieldOptions }) => fieldOptions === 'small' ? '6px' : '8px'};
	  height: ${({ fieldOptions }) => fieldOptions === 'small' ? '6px' : '8px'};
    border-radius: 50%;
    background: white;
  }`;
